<template>
  <div class="join_content">
    <div class="join_content_top">
      <div class="join_content_top_img"></div>
      <div class="join_content_top_border"></div>
    </div>
    <div class="join_content_form">
      <div class="profile_box">
        <div class="profile_text">프로필 이미지</div>

        <el-upload
            class="profile_upload_box"
            action=""
            list-type="picture"
            accept="image/* ,.png,.jpg"
            :file-list="files"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onlyOnePhotoChange"
        >
          <div v-if="!hasFile('files')" class="profile_upload_box_img"></div>
          <img class="profile_upload_box_after" v-if="hasFile('files')" :src="files[0].org_url">
          <div v-if="!hasFile('files')" @click="onlyOnePhotoChange" class="profile_upload_box_pencil"></div>
          <div v-else class="profile_upload_box_pencil"></div>
        </el-upload>
        <div v-if="!hasFile('files')">
          <div class="profile_upload_text">크기 204 x 204 에 최적화 되어있습니다.</div>
          <div class="message" v-if="validation.hasError('files')" v-html="validation.firstError('files')"></div>
        </div>

      </div>

      <div class="input_box name">
        <label class="box_text">이름</label>
        <el-input placeholder="이름을 입력해주세요" v-model="name"
                  maxLength="5"></el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('name')"
           v-html="validation.firstError('name')"></div>

      <div class="input_box job">
        <label class="box_text">직업</label>
        <el-input placeholder="직업을 입력해주세요" v-model="job" maxLength="20"></el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('job')"
           v-html="validation.firstError('job')"></div>

      <div class="input_box birthday">
        <label class="box_text">생년월일</label>
        <el-input type="tel" class="input_number" placeholder="YYYY MM DD" v-model="birthday"
                  maxLength="8"></el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('birthday')"
           v-html="validation.firstError('birthday')"></div>

      <div class="input_box phone">
        <label class="box_text">휴대전화</label>
        <el-input type="tel" placeholder="숫자만 입력해주세요" v-model="phone" maxLength="11"></el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('phone')"
           v-html="validation.firstError('phone')"></div>

      <div class="input_box email">
        <label class="box_text">이메일</label>
        <el-input placeholder="이메일을 입력해주세요" v-model="email"></el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('email')"
           v-html="validation.firstError('email')"></div>

      <div class="input_box address">
        <div class="box_text">주소</div>
        <el-select class="address_selectBox" v-model="addr1" placeholder="지역1" @change="selectSi($event)">
          <el-option
              v-for="item in siList"
              :key="item.ac_idx"
              :label="item.ac_si"
              :value="item.ac_idx">
          </el-option>
        </el-select>
        <el-select class="address_selectBox" v-model="addr2" placeholder="지역2" :disabled="hasGu()">
          <el-option
              v-for="item in guList"
              :key="item.ac_idx"
              :label="item.ac_gu"
              :value="item.ac_idx">
          </el-option>
        </el-select>
      </div>
      <div class="message ml0" v-if="validation.hasError('addr2')"
           v-html="validation.firstError('addr2')"></div>

      <div class="input_box introduce">
        <label class="box_text">자기소개</label>
        <el-input class="introduce_textarea"
                  type="textarea"
                  placeholder="자기소개를 입력해주세요"
                  v-model="introduce"
                  maxLength="100">
        </el-input>
      </div>
      <div class="message ml0" v-if="validation.hasError('introduce')"
           v-html="validation.firstError('introduce')"></div>

      <div class="input_box recommender">
        <label class="box_text">추천인</label>
        <el-input placeholder="추천인을 입력해주세요" v-model="recommender" >
        </el-input>
      </div>
      <div class="input_box agreeCheck">
        <input type="checkbox" id="agreeCheck_checkbox" :value="agree" @change="changAgree()"/>
        <label for="agreeCheck_checkbox"><span>개인정보처리방침에 동의합니다.</span></label>
        <span class="clause" @click="openModal()">[약관보기]</span>
      </div>
      <div class="message ml0" v-if="validation.hasError('agree')"
           v-html="validation.firstError('agree')"></div>

      <div class="submit_box">
        <button class="submit_box_btn" @click="checkValidator">아빠미소멘토단 가입신청</button>
      </div>
      <div class="message" v-if="checkAllValidator()">모두 입력해주세요</div>
    </div>
  </div>
</template>

<script>
import memberValidator from "@/mixins/validators/memberValidator";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";

export default {
  name: "RegistComponent",
  mixins: [memberValidator, alertMixins, elFileMixins],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      value: '',
      name: '',
      job: '',
      birthday: '',
      phone: '',
      email: '',
      addr1: '',
      addr2: '',
      recommender:'',
      siList: [],
      guList: [],

    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.getSiList();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(key, value) {
      this[key] = value;
      this.errorText = false;
    },
    changAgree() {
      this.agree = !this.agree
    },
    checkAllValidator() {
      return this.validation.hasError('name') || this.validation.hasError('email') || this.validation.hasError('birthday') || this.validation.hasError('job') || this.validation.hasError('addr2') || this.validation.hasError('introduce') || this.validation.hasError('files');
    },
    checkValidator() {
      let validatorCheck = ['name', 'email', 'phone', 'birthday', 'job', 'addr2', 'introduce', 'files', 'agree']
      this.$validate(validatorCheck).then(success => {
        if (!success) {
          this.hasError = true;
          this.agree = false;
          this.errorAlert('모두 입력해주세요.');
          return false;
        }
        this.memberRegist();
        return true;
      })
    },
    memberRegist() {
      let params = {
        m_name: this.name,
        m_email: this.email,
        m_birth: this.inputBirth(this.birthday),
        m_hp: this.phone,
        m_job: this.job,
        m_memo: this.introduce,
        ac_idx: this.addr2,
        m_recommender:this.recommender
      }
      try {
        this.$api.$member.applyMember(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type == 1) {
            this.uploadFiles(this.files, 'mentor', res.List).then(success => {
              if (!success) {
                this.errorAlert('가입신청이 실패하였습니다.')
              } else {
                this.createAlert({
                  content: '가입신청이 완료되었습니다.',
                  btnText: '확인',
                  hide: () => {
                    // this.initForm()
                    location.reload();
                  }
                })
              }
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getSiList() {
      let params = {si: 1}
      try {
        this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            this.errorAlert('지역 리스트를 불러올수 없습니다.');
          } else {
            this.siList = res.List;
          }
        })
      } catch (e) {
        console.log(e);
      }
    },
    selectSi(event) {
      this.getGuList(event)
      this.addr2 = ''
    },
    getGuList(gu) {
      let params = {gu: gu}
      try {
        this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            this.errorAlert(type)
          } else {
            this.guList = res.List
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    hasGu() {
      return util.isEmpty(this.guList)
    },
    inputBirth(value) {
      return this.$moment(value).format('YYYY-MM-DD')
    },
    initForm() {
      this.files = []
      this.name = ''
      this.job = ''
      this.birthday = ''
      this.phone = ''
      this.email = ''
      this.addr1 = ''
      this.addr2 = ''
      this.introduce = ''
      this.recommender=''
      this.agree = false
    },

    hasFile(typeName) {
      if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName]) && this[typeName][0].hasOwnProperty('org_url')) {
        return true;
      }
      return false;
    },
    openModal() {
      this.$modal.show('terms-modal', {termsType: 'privacy', scroll: window.pageYOffset});
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
